<form id="gebaeudetyp-dachung" [formGroup]="formGroup" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective">
<div *ngIf="showGroup">
  <div class="row">
    <div class="col col-xs-12 col-sm-12">
      <div class="input_radio">
        <app-label [control]="gebaeudetyp" for="gebaeudetyp">Geb&auml;udetyp</app-label>
        <mat-radio-group id="gebaeudetyp" formControlName="gebaeudetyp">
          <mat-radio-button *ngFor="let gb of GebaeudeTypen | keyvalue" [value]="gb.key">{{ gb.value}}</mat-radio-button>
        </mat-radio-group>
        <mat-error *ngIf="gebaeudetyp.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col col-xs-12 col-sm-12">
      <div class="input_radio">
        <app-label [control]="dachung" for="dachung">Dachung</app-label>
        <mat-radio-group id="dachung" formControlName="dachung">
          <mat-radio-button *ngFor="let d of Dachungen | keyvalue" [value]="d.key">{{ d.value}}</mat-radio-button>
        </mat-radio-group>
        <mat-error *ngIf="dachung.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
      </div>
    </div>
  </div>
</div>
</form>
